import React from 'react'

import { ReactComponent as WandIcon } from 'assets/images/reports/icons/ic-wand.svg'
import { buildTranslate } from 'locales'
import './ThanxAISuggestionChip.scss'

const t = buildTranslate('segments.ai_prompt')

export interface ThanxAISuggestionChipProps {
  suggestion: string
  onClick: (suggestion: string) => void
  inline?: boolean
  disabled?: boolean
}

const ThanxAISuggestionChip = ({
  suggestion,
  onClick,
  inline = false,
  disabled = false,
}: ThanxAISuggestionChipProps) => {
  const handleClick = () => {
    onClick(suggestion)
  }

  // Render as inline bordered chip
  if (inline) {
    return (
      <button
        type="button"
        className="thanx-ai-prompt__suggestion thanx-ai-prompt__suggestion--inline"
        onClick={handleClick}
        disabled={disabled}
        aria-label={t('aria_label_suggestion', { suggestion })}
      >
        <div className="thanx-ai-prompt__suggestion-icon" aria-hidden="true">
          <WandIcon />
        </div>
        <span className="thanx-ai-prompt__suggestion-text">{suggestion}</span>
      </button>
    )
  }

  // Render as list item on empty page
  return (
    <li>
      <button
        type="button"
        className="thanx-ai-prompt__suggestion"
        onClick={handleClick}
        disabled={disabled}
        aria-label={t('aria_label_suggestion', { suggestion })}
      >
        <div className="thanx-ai-prompt__suggestion-icon" aria-hidden="true">
          <WandIcon />
        </div>
        <span className="thanx-ai-prompt__suggestion-text">{suggestion}</span>
      </button>
    </li>
  )
}

export default ThanxAISuggestionChip
